export const GET_LOGIN_DATA = 'core-capital/LoginPage/GET_LOGIN_DATA';
export const SET_LOGIN_DATA = 'core-capital/LoginPage/SET_LOGIN_DATA';

export const GET_AUTH_TOKEN = 'core-capital/LoginPage/GET_AUTH_TOKEN';
export const DELETE_AUTH_TOKEN = 'core-capital/LoginPage/DELETE_AUTH_TOKEN';
